var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.2,
    height: 21.6,
    viewBox: "0 0 19.2 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-marker"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,19.2c0,.9-1,1.6-1.4,1.9A8.46,8.46,0,0,1,18,22c-.5.2-.8.2-1,.3a6.1,6.1,0,0,1-1.5.3,10.89,10.89,0,0,1-1.9.1H11.7a14.58,14.58,0,0,1-2.5-.2c-.7-.1-1.5-.2-2.5-.4a10.43,10.43,0,0,1-2.5-.8c-.8-.4-1.2-.6-1.5-1.1a1.72,1.72,0,0,1-.3-1,2.21,2.21,0,0,1,.4-1.3A2.15,2.15,0,0,1,4,17l.12,0,.09,0,.87-.33.72-.19a1.3,1.3,0,0,1,.35,0,1.84,1.84,0,0,1,.65.12.78.78,0,0,1,.3.6,1.12,1.12,0,0,1-.7.8L6,18.06a5.12,5.12,0,0,1-.64.2l-.46.17-.23.09a.6.6,0,0,0-.15,1.05A7.57,7.57,0,0,0,6,20.2a9.26,9.26,0,0,0,2.1.4,28.86,28.86,0,0,0,3.7.3H13a13.92,13.92,0,0,0,1.7-.1,12.5,12.5,0,0,0,1.9-.3l1.6-.4s.5-.2,1.1-.5a.7.7,0,0,0,.5-.5.6.6,0,0,0,0-.35l-.3-.19-.58-.21-.23-.08a2.52,2.52,0,0,0-.35-.07,2.79,2.79,0,0,1-.82-.32c-.28-.16-.44-.25-.52-.46a.84.84,0,0,1,0-.43.71.71,0,0,1,.17-.39.62.62,0,0,1,.4-.2h.3a4,4,0,0,1,1.3.3c.3.1.6.3.7.3a4.44,4.44,0,0,1,1.1.8A1.83,1.83,0,0,1,21.6,19.2Z",
    transform: "translate(-2.4 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,16.8C6.8,14.6,4.2,11,5.2,6.8a7.13,7.13,0,0,1,7.1-5.5h0a7,7,0,0,1,7.1,5.6c1,4.2-1.6,7.8-3.9,10a4.82,4.82,0,0,1-3.2,1.3A4.93,4.93,0,0,1,9.1,16.8ZM6.3,7.1C5.5,10.8,7.8,14,9.9,16a3.44,3.44,0,0,0,4.8,0c2.1-2,4.4-5.2,3.6-8.9a5.92,5.92,0,0,0-6-4.6A5.82,5.82,0,0,0,6.3,7.1Z",
    transform: "translate(-2.4 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3,8.3a4,4,0,1,1,4,4A4,4,0,0,1,8.3,8.3Zm.6,0a3.5,3.5,0,0,0,7,0,3.5,3.5,0,1,0-7,0Z",
    transform: "translate(-2.4 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-2.4 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-2.4 -1.1)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.a35abe6445ebe1845e7dfe0f42221575.svg";
export { ForwardRef as ReactComponent };